module.exports = __webpack_public_path__ + "img/ms_icon_1.b1db58bf.png";